module.exports = __webpack_public_path__ + "img/edge_nature_grotte.e625fafe.svg";